/**
 * Internal dependencies
 */
import { RootState } from './types';

export const isNavBarColor = (color: any): color is RootState['navBarColor'] =>
	['light', 'dark'].includes(color);
